import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";
import { FaMedal} from "react-icons/fa6";
import ViewLeave from "./view";
import EditLeave from "./edit";
import HyvidAwards from "./index";
import { MODULE_AWARDS } from "variables/constants";

const hyvidAwardRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Hyvid Awards",
		basePath: "hyvid-awards",
		mainComponent: <HyvidAwards />,
	    layout: "/console",	   
	    icon: <FaMedal className="icon-item" />,
	    subTitle:"Hyvid Awards",
	    viewComponent: <ViewLeave />,
	    createComponent: <EditLeave />,
	    editComponent: <EditLeave />,
		level:4,
		moduleId: MODULE_AWARDS,
	})
]

export default hyvidAwardRoutes;